import { connect } from 'react-redux'
import SchoolHeader from './school-header'
import { getSchool } from '../../../../../stores/school/school.selectors'

const mapStateToProps = (state, { me }) => {
  const school = getSchool(state)
  return {
    id: school.id,
    title: school.title,
    location: `${school.city}${school.country ? ', ' + school.country : ''}`,
    description: school.description,
    background: school.background_image_url,
    logo: school.logo_url && { url: school.logo_url },
    twitterHandler: school.twitter_handler,
    website: school.website
  }
}

export default connect(
  mapStateToProps,
  null
)(SchoolHeader)
